import { useRef, useState } from "react";
import { Volume2, VolumeX } from "lucide-react";
import Reveal from "@/components/escape21/Reveal";
import CtaWhats from "./CtaWhats";
import { SALES_VIDEO, SALES_POSTER } from "./constants";

const SalesProof = () => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [muted, setMuted] = useState(true);

  const toggleMute = () => {
    const video = videoRef.current;
    if (!video) return;
    const next = !muted;
    video.muted = next;
    if (!next) video.play().catch(() => {});
    setMuted(next);
  };

  return (
    <section className="px-6 py-20 sm:py-28">
      <div className="mx-auto max-w-3xl text-center">
        <Reveal>
          <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-white/35">
            conteúdo que vende
          </span>
          <h2 className="mx-auto mt-4 max-w-2xl text-3xl font-extrabold leading-tight tracking-[-0.03em] sm:text-5xl">
            quando eu abro algo, <span className="e21-serif text-green-400">vende</span>.
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-base text-white/55 sm:text-lg">
            abri um desafio e em menos de 24h as notificações de venda não pararam
            de pingar. sem anúncio. só o conteúdo puxando a galera pra ação.
          </p>
        </Reveal>

        <Reveal delay={120} className="mt-12">
          <div className="relative mx-auto w-full max-w-[320px] overflow-hidden rounded-2xl border border-white/10 bg-white/5">
            <video
              ref={videoRef}
              src={SALES_VIDEO}
              poster={SALES_POSTER}
              autoPlay
              muted
              loop
              playsInline
              preload="metadata"
              className="block h-auto w-full"
            />
            <button
              type="button"
              onClick={toggleMute}
              aria-label={muted ? "ativar som" : "desativar som"}
              className="absolute bottom-3 right-3 flex h-10 w-10 items-center justify-center rounded-full bg-black/60 text-white backdrop-blur transition-colors hover:bg-black/80"
            >
              {muted ? <VolumeX size={18} /> : <Volume2 size={18} />}
            </button>
          </div>

          <p className="mt-4 font-mono text-[11px] uppercase tracking-[0.3em] text-white/35">
            toque no som pra ouvir as vendas
          </p>
        </Reveal>

        <Reveal delay={200} className="mt-10">
          <CtaWhats label="quero esse resultado pra minha marca" className="px-8 py-4" />
        </Reveal>
      </div>
    </section>
  );
};

export default SalesProof;
